// ── Новый аудио-проект: загрузка файла ───────────────────────────────────────

import { useRef, useState } from "react";
import { t } from "../i18n";
import Icon from "../Icon";
import { SANS } from "../themes";
import { usePalette } from "../ui/theme";
import { panelSurface } from '../ui/surface';

// ── UploadScreen — загрузка аудио ────────────────────────────────────────────

export function UploadScreen({project,onUpload,onBack,theme,onTheme,uploading,compressProgress}){
  const C=usePalette();
  const [drag,setDrag]=useState(false);
  const ref=useRef();
  return(
    <div style={{minHeight:"100vh",background:C.backdrop,fontFamily:SANS,position:"relative"}}>
      <div style={{position:"sticky",top:0,zIndex:20,background:C.glassHdr,backdropFilter:"saturate(1.4) blur(16px)",WebkitBackdropFilter:"saturate(1.4) blur(16px)",borderBottom:`1px solid ${C.border}`,
        padding:"calc(8px + env(safe-area-inset-top, 0px)) 16px 8px",display:"flex",alignItems:"center",gap:12}}>
        <button data-btn="" onClick={onBack} aria-label={t("Назад")} title={t("Назад")} className="ac-ibtn"
          style={{width:40,height:40,flexShrink:0,display:"inline-flex",alignItems:"center",justifyContent:"center",background:C.lift?C.surface:"none",border:`1px solid ${C.border}`,borderRadius:8,color:C.mid,cursor:"pointer",padding:0}}>
          <Icon n="arrowLeft" s={18}/>
        </button>
        <div style={{fontSize:16,fontWeight:600,color:C.text}}>{project?t("Аудио для проекта"):t("Новое аудио")}</div>
      </div>
      <div style={{maxWidth:480,margin:"0 auto",padding:"28px 16px",position:"relative",zIndex:1}}>
        <h1 style={{fontSize:22,fontWeight:600,color:C.text,margin:"0 0 8px",overflow:"hidden",textOverflow:"ellipsis"}}>{project?project.name:t("Новый проект")}</h1>
        <p style={{fontSize:14,color:C.mid,lineHeight:1.6,margin:"0 0 20px"}}>{project?t("Выберите аудиофайл для этого проекта."):t("Выберите аудиофайл — он загрузится в облако и будет доступен офлайн.")}</p>
        {compressProgress!==null?(
          <div role="status" style={{background:C.card,borderRadius:12,border:`${C.borderW||1}px solid ${C.border}`,boxShadow:C.panelShadow,padding:"44px 20px",textAlign:"center"}}>
            <div style={{color:C.blueDark,marginBottom:10}}><Icon n="download" s={32} sw={1.5}/></div>
            <div style={{fontSize:15,fontWeight:600,color:C.text,marginBottom:10}}>{t("Сжимаем аудио…")} {compressProgress}%</div>
            <div style={{background:C.surface,borderRadius:99,height:6,overflow:"hidden",maxWidth:200,margin:"0 auto"}}>
              <div style={{height:"100%",width:`${compressProgress}%`,background:C.blue,borderRadius:99,transition:"width .3s ease"}}/>
            </div>
            <div style={{fontSize:12,color:C.faint,marginTop:8}}>{t("WAV → Opus · в 5–10 раз меньше")}</div>
          </div>
        ):uploading?(
          <div role="status" style={{background:C.card,borderRadius:12,border:`${C.borderW||1}px solid ${C.border}`,boxShadow:C.panelShadow,padding:"44px 20px",textAlign:"center"}}>
            <div style={{color:C.blueDark,marginBottom:10}}><Icon n="cloud" s={32} sw={1.5}/></div>
            <div style={{fontSize:15,fontWeight:600,color:C.text,marginBottom:5}}>{t("Загружаем в облако…")}</div>
            <div style={{fontSize:13,color:C.faint}}>{t("Для длинных файлов — минута-две")}</div>
          </div>
        ):(
          <div role="button" tabIndex={0} onClick={()=>ref.current.click()} onKeyDown={e=>{if(e.key==="Enter"||e.key===" "){e.preventDefault();ref.current.click();}}}
            onDragOver={e=>{e.preventDefault();setDrag(true);}} onDragLeave={()=>setDrag(false)} onDrop={e=>{e.preventDefault();setDrag(false);if(e.dataTransfer.files[0])onUpload(e.dataTransfer.files[0]);}}
            style={{border:`2px dashed ${drag?C.blue:C.border}`,borderRadius:12,padding:"48px 20px",textAlign:"center",cursor:"pointer",background:drag?C.bluePale:panelSurface(C).background,transition:"background .15s, border-color .15s"}}>
            <div style={{color:drag?C.blueDark:C.mid,marginBottom:12}}><Icon n="upload" s={36} sw={1.5}/></div>
            <div style={{fontSize:15,fontWeight:600,color:C.text,marginBottom:6}}>{t("Нажмите или перетащите файл")}</div>
            <div style={{fontSize:13,color:C.faint}}>MP3 · WAV · OGG · M4A · OPUS</div>
          </div>
        )}
        <input ref={ref} type="file" accept="audio/*" style={{display:"none"}} onChange={e=>e.target.files[0]&&onUpload(e.target.files[0])}/>
      </div>
    </div>
  );
}
